export interface OutageBannerConfig {
    isActive: boolean;
    title: string;
    message: string;
    sessionStorageKey: string;
}

export const OUTAGE_BANNER_CONFIG: OutageBannerConfig = {
    isActive: false,
    title: 'Upcoming Site Outage',
    message:
        'Easy Estimator will be unavailable due to scheduled maintenance, beginning Saturday, April 25 at 6:00 AM CST and ending Sunday, April 26 at 11:59 PM CST, as we work to improve performance and reliability',
    sessionStorageKey: 'sd-650-outage-banner-dismissed',
};
